import React, {useState} from 'react';
import ReactModal from "react-modal";

/* Icons */
import {
    CarLabelIcon,
    StarIcon,
    HeartIcon,
    ElectricIcon,
    PercentageIcon,
    ShieldIcon,
    LeafIcon,
    ClockIcon,
    FuelIcon,
    HedinIcon,
    PlugIcon,
    RepearIcon,
    TestDriveIcon,
    ViewIcon,
    InfoLabelIcon, ChevronIconRight, CrossIcon,
} from "../../common/Icons";

import {circInOut} from "../../config/easing";
import Img, {CloudimageProvider} from 'react-cloudimage-responsive';
import {cloudImageConfig} from '../../../cloudimage';

export default function ProductSticker({ sticker, stickerTooltips = {}, ...props }) {
    const [open, setOpen] = useState(false);

    if (!sticker || !sticker.name || !sticker.theme) return null;

    const tooltip = stickerTooltips?.[sticker?.tooltip_id] || null;

    function RenderIcon() {
        const icon = sticker.icon;

        switch (icon) {
            case 'car':
                return <CarLabelIcon className="icon icon--24" />;
            case 'star':
                return <StarIcon className="icon icon--24" />;
            case 'heart':
                return <HeartIcon className="icon icon--24" />;
            case 'electric':
                return <ElectricIcon className="icon icon--24" />;
            case 'percentage':
                return <PercentageIcon className="icon icon--24" />;
            case 'shield':
                return <ShieldIcon className="icon icon--24" />;
            case 'leaf':
                return <LeafIcon className="icon icon--24" />;
            case 'clock':
                return <ClockIcon className="icon icon--24" />;
            case 'fuel':
                return <FuelIcon className="icon icon--24" />;
            case 'hedin':
                return <HedinIcon className="icon icon--24" />;
            case 'plug':
                return <PlugIcon className="icon icon--24" />;
            case 'repair':
                return <RepearIcon className="icon icon--24" />;
            case 'test-drive':
                return <TestDriveIcon className="icon icon--24" />;
            case 'view':
                return <ViewIcon className="icon icon--24" />;
            default:
                return '';
        }
    }

    let badgeStickerPadding = '';
    if(sticker.icon !== 'none' && tooltip === null) {
        badgeStickerPadding = 'pr-2';
    } else if (sticker.icon === 'none' && tooltip !== null) {
        badgeStickerPadding = 'pl-2';
    } else if (sticker.icon === 'none' && tooltip === null) {
        badgeStickerPadding = 'px-2';
    }

    let badgeStickerModalPadding = '';
    if(sticker.icon !== 'none') {
        badgeStickerModalPadding = 'pr-2';
    }

    return (
        <>
            {tooltip ? (
                <button type="button" className="btn-unstyled" onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpen(true); }}>
                    <span className={`badge badge--${sticker.theme} badge--sticker badge-sticker-absolute d-flex ${badgeStickerPadding} cursor-pointer`}>
                        <RenderIcon />
                        <span className="badge__text align-self-center text-truncate">{sticker.name}</span>
                        <InfoLabelIcon className="icon icon--20 text-muted--60" />
                    </span>
                </button>
            ) : (
                <span className={`badge badge--${sticker.theme} badge--sticker badge-sticker-absolute d-flex ${badgeStickerPadding}`}>
                    <RenderIcon />
                    <span className="badge__text align-self-center text-truncate">{sticker.name}</span>
                </span>
            )}

            {tooltip ? (
                <ReactModal
                    isOpen={open}
                    onRequestClose={() => setOpen(false)}
                    appElement={document.body}
                    closeTimeoutMS={circInOut.duration * 1000}
                    className="ReactModal__Content ReactModal__Content--custom">
                    <div className="card card--wizard w-100">
                        <div className="card-header d-flex align-items-center justify-content-between flex-shrink-0">
                            <button
                                className="btn btn-link text-base d-flex align-items-center p-0"
                                type="button"
                                onClick={(e) => {
                                    e.preventDefault();
                                    setOpen(false);
                                }}
                                >
                                <ChevronIconRight className="icon icon--24 icon--reversed mr-1" />
                                <span className="font-weight-semi-bold">Sluiten</span>
                            </button>
                            <button
                                className="btn btn-link text-base p-0"
                                type="button"
                                aria-label="Close"
                                onClick={(e) => {
                                    e.preventDefault();
                                    setOpen(false);
                                }}
                            >
                            <CrossIcon className="icon icon--24" />
                            </button>
                        </div>
                        <div className="card-body">
                            <div className="position-relative mb-2 mb-lg-4">
                                {tooltip.image &&
                                    <CloudimageProvider config={cloudImageConfig}>
                                        <Img
                                            className="img-fluid rounded"
                                            src={tooltip.image}
                                            alt={sticker.name}
                                            ratio={1.5}
                                            width="460px"
                                            height="280px"
                                        />
                                    </CloudimageProvider>
                                }

                                <span className={`badge badge--${sticker.theme} badge--sticker ${tooltip.image ? 'badge-sticker-absolute' : ''}  ${badgeStickerModalPadding} d-flex align-items-center ${tooltip ? 'cursor-pointer' : ''}`}>
                                    <RenderIcon />
                                    <span className="badge__text text-truncate">{sticker.name}</span>
                                </span>
                            </div>

                            {tooltip.text &&
                                <div className="mt-lg-8" dangerouslySetInnerHTML={{ __html: tooltip.text }} ></div>
                            }
                        </div>
                    </div>
                </ReactModal>
            ) : null}
        </>
    );
}
